import { render, staticRenderFns } from "./shipping-notice.vue?vue&type=template&id=4216b270&scoped=true"
import script from "./shipping-notice.ts?vue&type=script&lang=ts&external"
export * from "./shipping-notice.ts?vue&type=script&lang=ts&external"
import style0 from "./shipping-notice.scoped.scss?vue&type=style&index=0&id=4216b270&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4216b270",
  null
  
)

export default component.exports